import { ZoneCGType } from '@/types/graphql/root';
import { atom } from 'jotai';

export const alertModalAtom = atom<{
  visible: boolean;
  title?: string;
  message?: string;
  subMessage?: string;
  onConfirm?: () => void;
  onOuterClick?: () => void;
}>({
  visible: false,
});

export const confirmModalAtom = atom<{
  visible: boolean;
  title?: string;
  message?: string;
  subMessage?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  onOuterClick?: () => void;
  confirmButtonText?: string;
  closeButtonText?: string;
}>({
  visible: false,
});

export const poiImagesModalAtom = atom<{
  visible: boolean;
  name?: string;
  images?: string[];
}>({
  visible: false,
});

export const centerToastModalAtom = atom<
  | {
      text: string;
      renderingTime: number;
      iconHidden?: boolean;
    }
  | undefined
>(undefined);

export const selectPoiDetailModalAtom = atom<
  | {
      modalType: 'modify' | 'add';
      modifyIndex: number | null;
      visible: true;
      name: string;
      address: string;
      poiType: string;
      placeId: string;
      accomm: {
        isVisit: boolean;
        days: number[];
        day: 'all' | number | null;
        time: 'all' | 1 | 2 | 3 | null;
      } | null;
      other: {
        day: 'all' | number | null;
        time: 'all' | 1 | 2 | 3 | null;
      } | null;
      zones: ZoneCGType[];
    }
  | {
      visible: false;
    }
>({ visible: false });

export const blackTransparentLoaderModalAtom = atom<boolean>(false);

export const tripShareModalAtom = atom<{
  tripName: string;
  isOwn: boolean;
} | null>(null);

export const addToTripModalAtom = atom<{
  poiId: string;
  placeId: string;
  type: string;
} | null>(null);

export const sideMenuModalAtom = atom<boolean>(false);

export const zzimcarToastAtom = atom<{
  visible: boolean;
  text: string;
  renderingTime?: number;
  type?: 'info' | 'error';
} | null>(null);
